import { Typography, TypographyProps } from '@mui/material';
import { styled } from '@mui/material/styles';

import { Montserrat } from 'styles/common-fonts';

export const HeadlineLargeStyled = styled(Typography)<TypographyProps>(() => ({
  fontFamily: Montserrat,
  fontWeight: 700,
  fontSize: '3rem',
}));
